import { IAuditEvent } from '../hooks/reactQuerys/AuditQueries';

/**
 * Der Vollzugsplan, den ein Vorgang beim Anlegen aus seiner
 * Rechtsgeschäftsart bekommt (#1330).
 *
 * Die einzelnen Phasen und Maßnahmen erzeugen kein eigenes Ereignis mehr — das
 * wären rund 24 Zeilen für eine einzige Handlung. Sie stehen als Liste im
 * `Metadata` des Sammeleintrags und werden erst auf Klick aufgeklappt.
 */
export interface ICompletionPlanItem {
  kind: string;
  name: string;
}

export const COMPLETION_PLAN_CREATED =
  'legal_transaction.completion_plan_created';

/**
 * Liest die Liste aus dem Ereignis.
 *
 * Defensiv, weil `Metadata` als JSON in der Datenbank liegt: ein alter oder
 * unerwarteter Inhalt darf die Protokollansicht nicht zerlegen. Im Zweifel
 * eine leere Liste — dann stehen nur die Mengen da.
 */
export const completionPlanItems = (
  event: IAuditEvent
): ICompletionPlanItem[] => {
  const raw = (event.Metadata ?? {})['items'];

  if (!Array.isArray(raw)) {
    return [];
  }

  return raw
    .filter(
      (entry): entry is Record<string, unknown> =>
        typeof entry === 'object' && entry !== null
    )
    .map(entry => ({
      kind: String(entry.kind ?? ''),
      name: String(entry.name ?? ''),
    }))
    .filter(item => item.name !== '');
};

/** true, wenn die Vorlage zu groß war und die Liste gekappt wurde. */
export const completionPlanTruncated = (event: IAuditEvent): boolean =>
  (event.Metadata ?? {})['truncated'] === true;
